<div class="service-page">

  <!-- HEADER -->
  <section class="service-header">

    <div class="header-left">

      <div class="header-icon">
        <i class="fas fa-sliders-h"></i>
      </div>

      <div>
        <h1>Service Availability</h1>

        <p>
          Manage which Nishwik services are available to users.
        </p>
      </div>

    </div>


    <button
      type="button"
      class="refresh-btn"
      (click)="refresh()"
      [disabled]="isLoading"
    >

      <i
        class="fas fa-sync-alt"
        [class.fa-spin]="isLoading"
      ></i>

      Refresh

    </button>

  </section>


  <!-- KPI -->
  <section class="summary-grid">

    <article class="summary-card">

      <div class="summary-icon total-icon">
        <i class="fas fa-th-large"></i>
      </div>

      <div>
        <span>Total Services</span>

        <strong>
          {{ totalCount }}
        </strong>
      </div>

    </article>


    <article class="summary-card">

      <div class="summary-icon active-icon">
        <i class="fas fa-check"></i>
      </div>

      <div>
        <span>Active On This Page</span>

        <strong>
          {{ activeServiceCount }}
        </strong>
      </div>

    </article>


    <article class="summary-card">

      <div class="summary-icon inactive-icon">
        <i class="fas fa-power-off"></i>
      </div>

      <div>
        <span>Inactive On This Page</span>

        <strong>
          {{ inactiveServiceCount }}
        </strong>
      </div>

    </article>

  </section>


  <!-- MAIN CARD -->
  <section class="services-panel">

    <div class="panel-header">

      <div>

        <h2>
          Services
        </h2>

        <p>
          Toggle a service to show or hide it for users.
        </p>

      </div>


      <div class="search-box">

        <i class="fas fa-search"></i>

        <input
          type="text"
          [(ngModel)]="searchText"
          (input)="onSearchChange()"
          placeholder="Search by service name or key..."
        />


        <button
          *ngIf="searchText"
          type="button"
          class="clear-search"
          (click)="clearSearch()"
        >

          <i class="fas fa-times"></i>

        </button>

      </div>

    </div>


    <!-- LOADING -->
    <div
      *ngIf="isLoading"
      class="loading-state"
    >

      <div class="loader"></div>

      <strong>
        Loading services
      </strong>

      <span>
        Please wait while service availability is loaded.
      </span>

    </div>


    <!-- TABLE -->
    <div
      class="table-container"
      *ngIf="
        !isLoading &&
        filteredServiceList.length > 0
      "
    >

      <table class="service-table">

        <thead>

          <tr>

            <th class="number-column">
              #
            </th>

            <th>
              Service
            </th>

            <th>
              Category
            </th>

            <th>
              Current Status
            </th>

            <th class="control-column">
              Availability
            </th>

          </tr>

        </thead>


        <tbody>

          <tr
            *ngFor="
              let item of filteredServiceList;
              let i = index;
              trackBy: trackByServiceId
            "
          >

            <td class="number-column">

              {{
                item.rowNum ||
                (
                  (pageNo - 1) *
                  pageSize +
                  i +
                  1
                )
              }}

            </td>


            <!-- SERVICE -->
            <td>

              <div class="service-info">

                <div
                  class="status-dot"
                  [class.on]="isServiceActive(item)"
                  [class.off]="!isServiceActive(item)"
                ></div>


                <div class="service-text">

                  <strong>
                    {{
                      getServiceDisplayName(
                        item.serviceKey
                      )
                    }}
                  </strong>

                  <code>
                    {{ item.serviceKey }}
                  </code>

                </div>

              </div>

            </td>


            <!-- CATEGORY -->
            <td>

              <span class="category-pill">

                {{
                  getServiceCategory(
                    item.serviceKey
                  )
                }}

              </span>

            </td>


            <!-- STATUS -->
            <td>

              <span
                class="status-pill"
                [class.status-enabled]="isServiceActive(item)"
                [class.status-disabled]="!isServiceActive(item)"
              >

                <i
                  class="fas"
                  [class.fa-check-circle]="isServiceActive(item)"
                  [class.fa-times-circle]="!isServiceActive(item)"
                ></i>

                {{
                  isServiceActive(item)
                    ? "Active"
                    : "Inactive"
                }}

              </span>

            </td>


            <!-- TOGGLE -->
            <td class="control-column">

              <div class="availability-control">

                <label class="toggle-switch">

                  <input
                    type="checkbox"
                    [checked]="isServiceActive(item)"
                    [disabled]="item.isUpdating"
                    (change)="onToggleService(item, $event)"
                  />

                  <span class="toggle-track">

                    <span class="toggle-thumb"></span>

                  </span>

                </label>


                <span
                  class="toggle-label"
                  [class.toggle-on]="isServiceActive(item)"
                  [class.toggle-off]="!isServiceActive(item)"
                >

                  {{
                    item.isUpdating
                      ? "Updating..."
                      : (
                          isServiceActive(item)
                            ? "Shown"
                            : "Hidden"
                        )
                  }}

                </span>

              </div>

            </td>

          </tr>

        </tbody>

      </table>

    </div>


    <!-- EMPTY -->
    <div
      class="empty-state"
      *ngIf="
        !isLoading &&
        filteredServiceList.length === 0
      "
    >

      <div class="empty-icon">

        <i class="fas fa-search"></i>

      </div>

      <h3>
        No services found
      </h3>

      <p>
        Try another search or refresh the service list.
      </p>

    </div>


    <!-- PAGINATION -->
    <div
      class="pagination-bar"
      *ngIf="
        !isLoading &&
        serviceList.length > 0
      "
    >

      <div class="pagination-left">

        <span>
          Rows per page
        </span>


        <select
          [value]="pageSize"
          (change)="onPageSizeChange($event)"
        >

          <option
            *ngFor="let size of pageSizeOptions"
            [value]="size"
          >

            {{ size }}

          </option>

        </select>


        <span class="record-count">

          {{
            ((pageNo - 1) * pageSize) + 1
          }}

          -

          {{
            pageNo * pageSize > totalCount
              ? totalCount
              : pageNo * pageSize
          }}

          of

          {{ totalCount }}

        </span>

      </div>


      <div class="pagination-buttons">

        <button
          type="button"
          class="page-arrow"
          [disabled]="pageNo <= 1"
          (click)="previousPage()"
        >

          <i class="fas fa-chevron-left"></i>

        </button>


        <button
          *ngFor="let page of pageNumbers"
          type="button"
          class="page-number"
          [class.active]="page === pageNo"
          (click)="goToPage(page)"
        >

          {{ page }}

        </button>


        <button
          type="button"
          class="page-arrow"
          [disabled]="pageNo >= totalPages"
          (click)="nextPage()"
        >

          <i class="fas fa-chevron-right"></i>

        </button>

      </div>

    </div>

  </section>


  <div class="service-note">

    <i class="fas fa-info-circle"></i>

    <div>

      <strong>
        Visibility control
      </strong>

      <span>
        ON sets IsEnabled = 1.
        OFF sets IsEnabled = 0.
        IsActive and IsDeleted are not changed by this control.
      </span>

    </div>

  </div>

</div>